<script setup>

import OrderCard from "@/components/PersonalAccount/OrdersView/OrderCard.vue";
import {computed, onMounted} from "vue";
import {DEFAULT_ORDERS_PER_PAGE, useOrdersStore} from "@/store/orders";
import usePagination from "@/composables/pagination";
import TablePager from "@/components/shared/TablePager.vue";
import EmptyCard from "@/components/shared/EmptyCard.vue";
import MainPreloader from "@/components/shared/MainPreloader.vue";

const ordersStore = useOrdersStore()
const ordersPagination = usePagination(ordersStore, DEFAULT_ORDERS_PER_PAGE, false);

const items = computed(() => {
  return ordersPagination.pageData.value;
})

async function fillData() {
  await ordersStore.clearData();
  await ordersPagination.initLoad();
}

onMounted(() => {
  fillData();
})

</script>

<template>
  <div class="ordersView">
      <h2 class="ordersView__title">Покупки</h2>
      <MainPreloader
          v-if="ordersStore.loading"
          position="fixed"
          :size="80"
          :stroke="3"
      />
      <EmptyCard v-if="!ordersStore.loading && !items?.length">
      </EmptyCard>
      <template v-else>
      <OrderCard
          v-for="item in items"
          :key="item.id"
          :order="item"
      />
    <TablePager
        v-if="ordersPagination.countPages.value > 1
          || ordersPagination.hasMoreData.value"
        :pagination="ordersPagination"
    ></TablePager>
      </template>
  </div>
</template>

<style scoped lang="scss">
.ordersView {
  display: flex;
  gap: 14px;
  flex-direction: column;

  &__title {
    margin: 0;
    color: var(--cd-text);
    font-size: clamp(22px, 3vw, 30px);
    font-weight: 500;
    text-align: left;
  }
}
</style>
